<template>
  <div>
    <!-- 顶部导航 -->
    <home-header v-if="pgType=='todo'" />

    <div class="previcw-info-page">
      <a-collapse ref="collapse" :default-active-key='panelKeys'>
        <a-collapse-panel v-for="(item, index) in itemList" :key="String(index)" :header="item.titleDesc">
          <StudentBaseInfo v-if="item.itemCode == 'BASE'" :editFlag="editFlag" :ref="'itemRef_' + item.itemCode" :fieldData="item.fieldData" :imgData="item.imgData" />
          <ItemListTable v-else :ref="'itemRef_' + item.itemCode" :itemColumn="item.columns" :editFlag="editFlag" :fieldData="item.fieldData" />
        </a-collapse-panel>
      </a-collapse>

      <a-form-item label="个人签名" style="margin-bottom: 0px">
        <img style="height: 120px" :src="signStr" alt="签名" v-show="signStr"/>
      </a-form-item>

      <div class="con-button">
        <a-button @click="closePage">关闭</a-button>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <Foot ref="footer" v-if="pgType=='todo'" />
  </div>
</template>

<script>
import HomeHeader from '@/common/components/Header'
import StudentBaseInfo from './components/StudentBaseInfo'
import ItemListTable from './components/ItemListTable'
import Foot from '@/common/components/Foot'
import { mapState } from 'vuex'

export default {
  name: 'FillInInformation',
  components: {
    HomeHeader,
    Foot,
    StudentBaseInfo,
    ItemListTable
  },
  data () {
    return {
      panelKeys: ['0', '1', '2', '3'],
      editFlag: false,
      projectId: this.$route.query.pid,
      bid: this.$route.query.bid,
      pgType: this.$route.query.pt || null,
      signStr: null,
      itemList: [],
      textAreaFields: []
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  created() {
    this.getProjectItems()
  },
  mounted () {
    // this.getStudentInfo()
  },
  methods: {
    // 查询项目条目配置
    getProjectItems() {
      const that = this
      const url = '/biz/infocollect/getProjectItems'
      const param = {
        pid: that.$route.query.pid
      }
      that.axios.get(url, { params: param }).then(res => {
        if (res.success) {
          that.getStudentInfo()

          const resData = res.result
          const itemList = resData.itemList || []
          itemList.forEach(item => {
            const itemCode = item.itemCode
            const fieldData = item.fieldData || []
            if (itemCode !== 'BASE') {
              let columns = []
              fieldData.forEach(item => {
                let dataIndex = item.index
                let tmpColumn = {
                  title: item.label,
                  dataIndex: dataIndex,
                  align: 'center',
                  width: 150,
                  ellipsis: true
                }
                columns.push(tmpColumn)
              })
              item.columns = columns
            } else {
              that.textAreaFields = []
              fieldData.forEach(item => {
                if (item.type === 'textarea') {
                  that.textAreaFields.push(item.index)
                }
              })
            }
          })
          that.itemList = itemList
        }
      })
    },

    // 查询学生采集信息
    getStudentInfo() {
      const that = this
      const userInfo = that.common.getStorage('userInfo', true)
      const url = '/biz/infocollect/getCollectStudent'
      const param = {
        pid: that.$route.query.pid,
        sid: userInfo.id
      }
      that.axios.get(url, { params: param }).then(res => {
        if (res.success) {
          const resData = res.result
          that.textAreaFields.forEach(item => {
            if (!resData[item]) {
              resData[item] = '无'
            }
          })
          that.$refs['itemRef_BASE'][0].formData = resData
          that.signStr = resData.sign

          const itemDetails = resData.itemDetails || []
          const groups = []
          const itemCodeList = []
          if (itemDetails.length > 0) {
            itemDetails.forEach(item => {
              if (item.endDate === '9999-12-31') {
                item.endDate = '至今'
              }
              item.tmpId = item.id
              if (itemCodeList.indexOf(item.itemCode) === -1) {
                itemCodeList.push(item.itemCode)
              }
              if (!groups[item.itemCode]) {
                groups[item.itemCode] = []
              }
              groups[item.itemCode].push(item)
            })
            itemCodeList.forEach(item => {
              let ref = 'itemRef_' + item
              that.$refs[ref][0].dataSource = groups[item]
            })
          }
        }
      })
    },

    // 关闭页面
    closePage () {
      let path = `/personalcenters/infocollectindex?pid=${this.projectId}`
      if (this.pgType) {
        path = path + `&pt=${this.pgType}`
      }
      if (this.bid) {
        path = path + `&bid=${this.bid}`
      }
      this.$router.push({path: path})
    }
  }
}
</script>
<style scoped>
.previcw-info-page {
  width: 1208px;
  background-color: #F8F8FF;
  margin: 0 auto;
  padding: 12px 24px;
}
.previcw-info-page >>> .ant-collapse-header {
  background: rgba(44, 175, 122, 0.18);
  text-align: left;
  font-weight: 400;
  font-size: 18px;
  height: 45px;
}
.previcw-info-page >>> .ant-collapse-content-box{
  padding: 0;
}
.con-button {
  padding: 12px 0;
  text-align: center;
}

.con-button button {
  width: 150px;
  height: 35px;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/pages/infocollect/PreviewInfo.vue